import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/dynamic-pdf-templates/{id}']['GET'];

type Input = {
  id: string;
};

type Output = ThisApi['response'];

const getDynamicPdfTemplateById = async ({ id }: Input): Promise<Output> => {
  try {
    const response = await formsBackendClient.get(`/dynamic-pdf-templates/${id}`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch dynamic PDF template by id:', error);
    throw error;
  }
};

export default getDynamicPdfTemplateById;
